var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 30 30",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-41.4,70.3h-5c-0.6,0-1.1-0.5-1.1-1.1v-9.9c0-0.6,0.5-1.1,1.1-1.1h5c0.6,0,1.1,0.5,1.1,1.1v9.9C-40.3,69.8-40.8,70.3-41.4,70.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-30,70.3h-5c-0.6,0-1.1-0.5-1.1-1.1V42.3c0-0.6,0.5-1.1,1.1-1.1h5c0.6,0,1.1,0.5,1.1,1.1v26.9C-28.9,69.8-29.4,70.3-30,70.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-18.7,70.3h-5c-0.6,0-1.1-0.5-1.1-1.1V51.8c0-0.6,0.5-1.1,1.1-1.1h5c0.6,0,1.1,0.5,1.1,1.1v17.3C-17.5,69.8-18,70.3-18.7,70.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-40.9,30.5h-5c-0.6,0-1.1-0.5-1.1-1.1v-9.9c0-0.6,0.5-1.1,1.1-1.1h5c0.6,0,1.1,0.5,1.1,1.1v9.9C-39.8,30-40.3,30.5-40.9,30.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-29.5,30.5h-5c-0.6,0-1.1-0.5-1.1-1.1V2.5c0-0.6,0.5-1.1,1.1-1.1h5c0.6,0,1.1,0.5,1.1,1.1v26.9C-28.4,30-28.9,30.5-29.5,30.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M-18.2,30.5h-5c-0.6,0-1.1-0.5-1.1-1.1V12c0-0.6,0.5-1.1,1.1-1.1h5c0.6,0,1.1,0.5,1.1,1.1v17.3C-17,30-17.5,30.5-18.2,30.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1,69.3H1.6c-0.6,0-1.1-0.5-1.1-1.1V57.7c0-0.6,0.5-1.1,1.1-1.1h10.5c0.6,0,1.1,0.5,1.1,1.1v10.5C13.3,68.8,12.7,69.3,12.1,69.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1,52.1H1.6c-0.6,0-1.1-0.5-1.1-1.1V40.4c0-0.6,0.5-1.1,1.1-1.1h10.5c0.6,0,1.1,0.5,1.1,1.1v10.5C13.3,51.6,12.7,52.1,12.1,52.1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4,52.1H18.9c-0.6,0-1.1-0.5-1.1-1.1V40.4c0-0.6,0.5-1.1,1.1-1.1h10.5c0.6,0,1.1,0.5,1.1,1.1v10.5C30.5,51.6,30,52.1,29.4,52.1z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4,69.3H18.9c-0.6,0-1.1-0.5-1.1-1.1V57.7c0-0.6,0.5-1.1,1.1-1.1h10.5c0.6,0,1.1,0.5,1.1,1.1v10.5C30.5,68.8,30,69.3,29.4,69.3z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6,30H1.1C0.5,30,0,29.5,0,28.9V18.4c0-0.6,0.5-1.1,1.1-1.1h10.5c0.6,0,1.1,0.5,1.1,1.1v10.5C12.8,29.5,12.2,30,11.6,30z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6,12.8H1.1c-0.6,0-1.1-0.5-1.1-1.1V1.1C0,0.5,0.5,0,1.1,0h10.5c0.6,0,1.1,0.5,1.1,1.1v10.5C12.8,12.2,12.2,12.8,11.6,12.8z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9,12.8H18.4c-0.6,0-1.1-0.5-1.1-1.1V1.1c0-0.6,0.5-1.1,1.1-1.1h10.5C29.5,0,30,0.5,30,1.1v10.5C30,12.2,29.5,12.8,28.9,12.8z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9,30H18.4c-0.6,0-1.1-0.5-1.1-1.1V18.4c0-0.6,0.5-1.1,1.1-1.1h10.5c0.6,0,1.1,0.5,1.1,1.1v10.5C30,29.5,29.5,30,28.9,30z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGrid);
export default __webpack_public_path__ + "static/media/icon-grid.b7c891ab84232b6ff689b30f8b75edac.svg";
export { ForwardRef as ReactComponent };